import { render, staticRenderFns } from "./DataListCSV.vue?vue&type=template&id=036e5b4b&scoped=true&"
import script from "./DataListCSV.vue?vue&type=script&lang=js&"
export * from "./DataListCSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e5b4b",
  null
  
)

export default component.exports